'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = require('../../lib/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'spinner': 'Spinner__spinner___2UZXy',
  'spin': 'Spinner__spin___23ZhJ',
  'shadow': 'Spinner__shadow___3mQfN',
  'small': 'Spinner__small___2CPVz',
  'tiny': 'Spinner__tiny___mLmnI',
  'colorDarkSolid': 'Spinner__colorDarkSolid___2nYuq',
  'colorLightSolid': 'Spinner__colorLightSolid___198aF',
  'colorDarkTransparent': 'Spinner__colorDarkTransparent___KH8Vy Spinner__colorDarkSolid___2nYuq',
  'colorLightTransparent': 'Spinner__colorLightTransparent___3vGaM Spinner__colorLightSolid___198aF',
  'colorDarkShadow': 'Spinner__colorDarkShadow___3N9s_',
  'colorLightShadow': 'Spinner__colorLightShadow___275Pk'
};

var DefaultSpinner = (0, _mergeThemeHoc2.default)(style)(_Spinner2.default);
DefaultSpinner.displayName = 'DefaultSpinner';
exports.default = DefaultSpinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Spinner/index.js
// module id = ./node_modules/dibs-elements/dist/Spinner/index.js
// module chunks = 4